<template>
    <router-link :to="to|tr" class="sub-menu-item">
        <slot name="icon">
            <b-img v-if="src" class="icon" :src="src"></b-img>
            <i v-else class="icon fal" :class="icon"></i>
        </slot>
        <div class="name">
            <slot></slot>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: `sub-menu-item`,
        props: {
            src: { type: String },
            icon: { type: String },
            to: { type: String }
        }
    }
</script>

<style lang="scss" scoped>
    .sub-menu-item {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        width: 120px;
        padding: 10px;
        margin: 6px 0;
        position: relative;
        color: #fff;
        opacity: 0.8;
        transition: opacity 150ms;
        letter-spacing: 1px;
        font-size: 9pt;
        text-decoration: none !important;
        border-radius: 8px;
        overflow: hidden;

        &:hover {
            opacity: 1;
            background: rgba(white, 0.05);
        }

        &.router-link-exact-active {
            opacity: 1;
            background: rgba(white, 0.1);
        }

        .icon {
            width: 50px;
            height: 38px;
            object-fit: contain;
            display: block;
        }

        .name {
            display: flex;
            height: 31px;
            align-items: center;
            white-space: initial;
        }

        i.icon {
            font-size: 30px;
            line-height: 38px;
        }
    }

    @media (max-width: 576px) {
        .sub-menu-item {
            margin: 3px 0;
            padding: 5px;
            width: 100px;

            .name {
                font-size: 8pt;
            }
        }
    }
</style>
